import {login, logout} from '@/api/user'
import { Message } from 'element-ui'
import {
    getToken,
    setToken,
    removeToken,
    getLoginUser, setLoginUser, removeAll
} from '@/utils/auth'
import {resetRouter} from '@/router'

const getDefaultState = () => {
    return {
        token: getToken(),
        user: {}
    }
}

const state = getDefaultState()

const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USER: (state, data) => {
        state.user = data
    },
}

const actions = {
    // user login
    login({commit}, loginForm) {
        return new Promise((resolve, reject) => {
            login(loginForm).then(response => {
                /**
                 * data ↓↓↓
                 expire: 604800
                 token: "2vqrhCKLTRbLSMHFI2ZHWA=="
                 user: {id: 1, role: 0, admin_id: null, department_id: null, username: "admin", password: "123456",…}
                 */
                if(response.code == 200){
                    const {data} = response
                    commit('SET_TOKEN', data.token)
                    commit('SET_USER', data.user.user)
                    setToken(data.token, data.expire)
                    setLoginUser(data.user, data.expire)
                }else{
                    Message({
                        message: response.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // get user info
    getInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            const user = getLoginUser()
            if (user) {
                commit('SET_USER', user)
                resolve(user)
            } else {
                reject('登录失效，请重新登录')
            }
        })
    },

    // user logout
    logout({commit, state}) {
        return new Promise((resolve, reject) => {
            logout().then(response => {
              if (response.code == 200) {
                removeToken() // must remove  token  first
                removeAll()
                commit('RESET_STATE')
              }
              resetRouter()
              resolve()
            }).catch(error => {
              reject(error)
            })
          })
    },

    // remove token
    resetToken({commit}) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            removeAll()
            commit('RESET_STATE')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

